import {NgModule} from '@angular/core';
import {SeoService} from "@app/presentation/services/seo/seo.service";


@NgModule({
    declarations: [],
    imports: [

    ],
    providers: [
        SeoService
    ]
})
export class SeoModule { }
